<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_iii"></a><strong>T.H.U.G. L.I.F.E.</strong></h1>
<p class="author"><strong>a novel by<br/>SANYIKA SHAKUR</strong></p>
<p class="publisher"><img alt="Images" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5ef07788